<template>
	<ui-thread-upload
		:required="true"
		defaultLabel="Wiegenote"
		:labelOptions="labelOptions"
		:threadId="thread.id"
		:publicUpload="false"
		:form="form"
		v-on:new-upload="newUpload()"
	/>
</template>

<script>
export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			labelOptions: [
				{
					id: "Weighing slip",
					label: "Weighing slip",
				},
				{
					id: null,
					label: "Other ",
				},
			],
			form: Vue.observable(
				this.$inertia.form({
					file: null,
					label_id: null,
					thread_id: this.thread.id,
					public: false,
				})
			),
		};
	},
	methods: {
		async newUpload() {
			// update thread
			this.$bus.$emit("thread-needs-update", this.thread.id);
			this.$emit("done");
		},
	},
};
</script>
